export type TaskNavQuickCreateType =
  | 'task'
  | 'task-ai'
  | 'task-list'
  | 'tag'
  | 'screen';

export const TASK_NAV_QUICK_CREATE_EVENT = 'task-nav:quick-create';

export const emitTaskNavQuickCreate = (type: TaskNavQuickCreateType) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent<TaskNavQuickCreateType>(TASK_NAV_QUICK_CREATE_EVENT, {
      detail: type,
    }),
  );
};
